var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMesPrefs = function SvgIconMesPrefs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-mes-prefs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M460.5 137.85h-9a3.5 3.5 0 0 0 0 7h9a3.5 3.5 0 0 0 0-7Z",
    transform: "translate(-447 -136.85)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(2.5 2.5)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M460.5 146.787h-9a3.5 3.5 0 0 0 0 7h9a3.5 3.5 0 0 0 0-7Z",
    transform: "translate(-447 -136.85)",
    fill: "#8ccd32"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(11.5 11.437)",
    fill: "#467846"
  }))));
};
export { SvgIconMesPrefs as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1tZXMtcHJlZnMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiB2aWV3Qm94PSIwIDAgMTggMTgiPgogIDxyZWN0IGlkPSJhcmVhIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9IiNlYmViZWIiIG9wYWNpdHk9IjAiLz4KICA8ZyBpZD0iaWNvbiI+CiAgICA8cGF0aCBpZD0iUGF0aF84MiIgZGF0YS1uYW1lPSJQYXRoIDgyIiBkPSJNNDYwLjUsMTM3Ljg1aC05YTMuNSwzLjUsMCwwLDAsMCw3aDlhMy41LDMuNSwwLDAsMCwwLTdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQ3IC0xMzYuODUpIiBmaWxsPSIjYjdiN2I3Ii8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzEzIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTMiIGN4PSIyIiBjeT0iMiIgcj0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi41IDIuNSkiIGZpbGw9IiM1MDUwNTAiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzgzIiBkYXRhLW5hbWU9IlBhdGggODMiIGQ9Ik00NjAuNSwxNDYuNzg3aC05YTMuNSwzLjUsMCwwLDAsMCw3aDlhMy41LDMuNSwwLDAsMCwwLTdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQ3IC0xMzYuODUpIiBmaWxsPSIjOGNjZDMyIi8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzE0IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTQiIGN4PSIyIiBjeT0iMiIgcj0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuNSAxMS40MzcpIiBmaWxsPSIjNDY3ODQ2Ii8+CiAgPC9nPgo8L3N2Zz4K";